export enum Asset {
  NotFound = 'asset.not.found',
}

export enum AssetSelectionSet {
  NotFound = 'asset.selection.set.not.found',
}

export enum Benchmark {
  AlreadyMapped = 'benchmark.already.mapped',
  AnotherBenchmarkAlreadyMapped = 'benchmark.another.benchmark.already.mapped',
  CannotHaveReturnComponentWithBothBenchmarkAndAsset = 'benchmark.return.component.ids.mutually.exclusive',
  CannotMapToReturnComponent = 'benchmark.cannot.map.to.return.component',
  DuplicateTimeWindows = 'benchmark.duplicate.time.windows',
  LineItemsWithDuplicateWeightingComponents = 'benchmark.line.item.with.duplicate.weighting.components',
  NameExceedsMaxChars = 'benchmark.name.exceeds.max.characters',
  NameInUse = 'benchmark.name.in.use',
  NotFound = 'benchmark.not.found',
  OfTypeNotFound = 'benchmark.of.type.not.found',
  NoLineItems = 'benchmark.no.line.items',
  NoTimeWindows = 'benchmark.no.time.windows',
  OnlyDailyCanHaveCalendar = 'benchmark.only.daily.can.have.calendar',
  ReturnComponentMissing = 'benchmark.return.component.missing',
  SelfDependency = 'benchmark.self.dependency',
  TimeWindowsNotAlignedWithCalculationFrequency = 'benchmark.time.windows.not.aligned',
  NotLaggedAndCustomLagDayProvided = 'benchmark.not.lagged.and.lag.day.provided',
  CustomLagDayBeforeInceptionDay = 'benchmark.lag.day.before.inception.day',
}

export enum AbsoluteReturn {
  DailyRequiresNumberOfDaysInYear = 'benchmark.absolute.return.daily.requires.num.days.in.year',
  OnlyDailyCanHaveNumberOfDaysInYear = 'benchmark.absolute.return.only.daily.can.have.num.days.in.year',
}

export enum AssetWeighted {
  PreviewTimeWindowDuplicateResourceIdsProvided = 'benchmark.asset.weighted.preview.time.window.duplicate.resource.ids',
}

export enum CompositeWeighted {
  DuplicateTagIds = 'benchmark.composite.weighted.duplicate.tag.ids',
  TagAndAncestorProvided = 'benchmark.composite.weighted.tag.and.ancestor.provided',
}
export enum PullForward {
  PullForwardLengthLessThanOne = 'benchmark.pull.forward.length.less.than.one',
  PullForwardLengthGreaterThan100Years = 'benchmark.pull.forward.length.greater.than.100.years',
  ReturnComponentIsPullForward = 'benchmark.pull.forward.return.component.pull.forward',
}

export enum StaticWeighted {
  OnlyDailyCanHaveDailyToMonthlyLinking = 'benchmark.static.weighted.only.daily.can.have.daily.to.monthly.linking',
  OnlyDailyOrMonthlyRebalanceCanHaveDailyToMonthlyLinking = 'benchmark.static.weighted.only.daily.or.monthly.rebal.can.have.daily.to.monthly.linking',
  TimeWindowWeightNot100Percent = 'benchmark.static.weighted.timewindow.weight.not.100.percent',
}

export enum BenchmarkDependencies {
  BenchmarkNotFound = 'benchmark.dependencies.benchmark.not.found',
  CannotRemoveBenchmarkWithDependents = 'benchmark.dependencies.cannot.remove.benchmark.with.dependents',
  CircularDependency = 'benchmark.dependencies.circular.dependency',
  DependencyAlreadyExists = 'benchmark.dependencies.already.exists',
  DependencyNotFound = 'benchmark.dependencies.dependency.not.found',
}
export enum CalculationStorage {
  UnableToDetermineBenchmarkType = 'calculation.storage.bad.benchmark.type.id',

  UnableToDeserializeBenchmark = 'calculation.storage.unable.deserialize.benchmark',
}
export enum Calendar {
  CannotExcludeEveryDayOfTheWeek = 'calendar.cannot.exclude.every.day.of.week',

  NotFound = 'calendar.not.found',
}
export enum ContributionToReturn {
  InvalidContributionToReturnRowKeyFormat = 'contribution.to.return.invalid.row.key.format',
}
export enum Currency {
  CurrencyCodeExceedsMaxChars = 'currency.code.exceeds.max.characters',
  NotFound = 'currency.not.found',
}

export enum Day {
  BeforeEpoch = 'day.before.epoch',
  Invalid = 'day.not.valid',
}

export enum DayRange {
  ToDayCannotBeBeforeFromDay = 'day.range.to.day.cannot.be.before.from.day',
}

export enum Entity {
  NotFound = 'entity.not.found',
}

export enum General {
  StringExceedsMaxChars = 'general.string.exceeds.max.characters',
  RequiredStringIsMissing = 'general.string.is.null.or.empty',
  RequiredValueIsNull = 'general.value.is.null',
  EnumNameNotFound = 'general.enum.name.not.found',
  EnumIntValueNotFound = 'general.enum.int.value.not.found',
  EnumByteValueNotFound = 'general.enum.byte.value.not.found',
}

export enum Job {
  AlreadyDisabled = 'job.cannot.already.disabled',
  AlreadyEnabled = 'job.cannot.already.enabled',
  CannotContainDuplicateBenchmarks = 'job.cannot.contain.duplicate.benchmarks',
  CannotDisableImmediateJob = 'job.cannot.disable.immediate.job',
  CannotRunDisabledJob = 'job.cannot.run.disabled.job',
  CannotRunJobWithoutBenchmarks = 'job.cannot.run.job.without.benchmarks',
  CannotUpdateImmediateJob = 'job.cannot.update.immediate.job',
  CannotUpdateScheduledJobWithoutSchedulerJobId = 'job.cannot.update.scheduled.job.without.scheduler.id',
  DayRangeToDayMustBeMonthEnd = 'job.day.range.to.day.must.be.month.end',
  DayRangeFromDayMustBeMonthEnd = 'job.day.range.from.day.must.be.month.end',
  DayRangeFromDayCannotEqualToDay = 'job.day.range.from.day.cannot.equal.to.day',
  InvalidSchedule = 'job.schedule.not.valid',
  NameInUse = 'job.name.in.use',
  NoBenchmarks = 'job.no.benchmarks',
  BenchmarkIdsMustBeNullOrEmptyWhenIncludeAllBenchmarks = 'job.benchmarks.not.null.empty.when.include.all.benchmarks',
  NotFound = 'job.not.found',
  NumberOfQuartersBackLessThanOne = 'job.number.quarters.back.less.than.one',
  ScheduledJobRequiresSchedulerJobId = 'job.scheduled.requires.scheduler.job.id',
}

export enum JobHistory {
  NotFound = 'job.history.not.found',
}

export enum LagDay {
  MustBeMonthEnd = 'lag.day.must.be.month.end',
}

export enum PerformanceVariation {
  NotFound = 'performance.variation.not.found',
  PerformanceVariationExceedsMaxChars = 'performance.variation.exceeds.max.characters',
}

export enum RebalanceFrequency {
  CannotProvideCustomMonthsForNonCustomType = 'rebalance.frequency.cannot.provide.custom.months.for.non.custom.type',
  MustProvideCustomMonthsForCustomType = 'rebalance.frequency.must.provide.custom.months.for.custom.type',
  NotFound = 'rebalance.frequency.not.found',
}

export enum Streams {
  NotFound = 'streams.not.found',
  BenchmarkPerformanceReturnNotFound = 'streams.benchmark.performance.return.not.found',
  CalculationFrequencyMismatch = 'streams.calculation.frequency.mismatch',
}

export enum TagRefPropertyDefinition {
  NotFound = 'tag.ref.property.definition.not.found',
}

export enum TagSet {
  TagNotFound = 'tag.set.tag.not.found',
}

export enum ValueType {
  NotFound = 'value.type.not.found',
}
